import { FEEDBACK_SECTION } from '../actions/types'

const initialState = []

const feedbackDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case FEEDBACK_SECTION:
      return action.payload
    default:
      return state
  }
}

export default feedbackDataReducer
